export var getDefaultAtlasBaseURL = function getDefaultAtlasBaseURL(isGlobalExperienceWorkspace) {
  var hostname = window.location.hostname;
  var subdomain = isGlobalExperienceWorkspace ? 'home' : 'team';
  if (hostname.includes('jira-dev.com') || hostname.includes('.stg.atlassian.') || hostname.startsWith('localhost')) {
    return "https://".concat(subdomain, ".stg.atlassian.com");
  }
  return "https://".concat(subdomain, ".atlassian.com");
};
export var createGlobalExperienceLink = function createGlobalExperienceLink(entityId, path, isGlobalExperienceWorkspace, orgId) {
  var baseUrl = getDefaultAtlasBaseURL(isGlobalExperienceWorkspace);
  if (isGlobalExperienceWorkspace && orgId) {
    return "".concat(baseUrl, "/o/").concat(orgId, "/").concat(path, "/").concat(entityId);
  }
  return "".concat(baseUrl, "/").concat(path, "/").concat(entityId);
};
export var createProfileLink = function createProfileLink(accountId, isGlobalExperienceWorkspace, orgId) {
  return createGlobalExperienceLink(accountId, 'people', isGlobalExperienceWorkspace, orgId);
};
export var createTeamProfileLink = function createTeamProfileLink(teamId, isGlobalExperienceWorkspace, orgId) {
  return createGlobalExperienceLink(teamId, 'people/team', isGlobalExperienceWorkspace, orgId);
};
var getAtlasViewAllRedirectUrl = function getAtlasViewAllRedirectUrl(entity, searchText, workspaces, isGlobalExperienceWorkspace, orgId) {
  var url;
  if (workspaces && workspaces.length === 1 && /team\.(stg\.)?atlassian\.com/.test(workspaces[0].baseUrl)) {
    url = new URL(workspaces[0].baseUrl);
  } else {
    url = new URL(getDefaultAtlasBaseURL(isGlobalExperienceWorkspace));
  }
  var pathPrefix = isGlobalExperienceWorkspace && orgId ? "o/".concat(orgId, "/") : '';
  url.pathname = "".concat(pathPrefix, "action/search/").concat(entity);
  url.searchParams.append('searchText', searchText);
  return url.href;
};
export default getAtlasViewAllRedirectUrl;